// extracted by mini-css-extract-plugin
export default {"sortContainer":"SortComponent_sortContainer__DnYJK"};